import { fetchAuthSession } from 'aws-amplify/auth'

export const getIdToken = async (): Promise<string> => {
  const session = await fetchAuthSession()

  const token = session.tokens?.idToken?.toString()

  if (!token) {
    throw new Error('No ID token available')
  }
  return token
}

export const waitForToken = async (maxWaitMs = 5000): Promise<string> => {
  return await new Promise((resolve, reject) => {
    const startTime = Date.now()

    const checkToken = (): void => {
      const token = localStorage.getItem('token')
      if (token) {
        resolve(token)
        return
      }

      if (Date.now() - startTime >= maxWaitMs) {
        reject(new Error(`Token not available after waiting ${maxWaitMs}ms`))

        return
      }

      setTimeout(checkToken, 100)
    }

    checkToken()
  })
}

export const waitForStableSession = async (timeoutMs = 3000): Promise<void> => {
  const start = Date.now()
  while (true) {
    const session = await fetchAuthSession()
    const id = session.tokens?.idToken?.toString()
    const access = session.tokens?.accessToken?.toString()
    if (id && access) return
    if (Date.now() - start > timeoutMs) return
    await new Promise(resolve => setTimeout(resolve, 100))
  }
}
